"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const Runtime_1 = require("../../types/Runtime");
const writeFunctionOutputToRegistry_1 = __importDefault(require("../../shared/writeFunctionOutputToRegistry"));
const callableObjectFilter = async ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.PREDICATE]: predicateEntryVar, [General_1.DEFINITION_PROP_NAMES.OBJECT]: objectEntryVar, }, processor, functionId, lastFunctionsOutputs, extraFunctionDefinitions, }) => {
    const onError = (error) => {
        if (processor.root.isInDevelopment) {
            processor.root.alert('Error object filter', error);
        }
    };
    if (!(0, ts_validators_1.valueIsRecord)(objectEntryVar)) {
        onError('The object is not valid');
        return {};
    }
    if (typeof predicateEntryVar !== 'function') {
        onError('The predicate is not a valid function');
        return {};
    }
    let hasSomeItemTimedOut = false;
    const objectEntries = Object.entries(objectEntryVar);
    const solveOneItem = (key, item, index) => new Promise((resolve) => {
        let isSolved = false;
        predicateEntryVar({
            lastFunctionsOutputs: (0, writeFunctionOutputToRegistry_1.default)(lastFunctionsOutputs, functionId, { key, item, index }),
            extraFunctionDefinitions: Object.assign(Object.assign({}, extraFunctionDefinitions), { [Runtime_1.SPECIAL_CALLBACK_NAMES.TRUE]: () => {
                    isSolved = true;
                    resolve(true);
                }, [Runtime_1.SPECIAL_CALLBACK_NAMES.FALSE]: () => {
                    isSolved = true;
                    resolve(false);
                } }),
        });
        setTimeout(() => {
            if (isSolved) {
                return;
            }
            if (hasSomeItemTimedOut) {
                resolve(false);
                return;
            }
            hasSomeItemTimedOut = true;
            onError('The predicate function timed out!');
            resolve(false);
        }, 5000);
    });
    const filterItemsFlags = await Promise.all(objectEntries
        .map(async ([key, item], index) => solveOneItem(key, item, index)));
    return objectEntries.reduce((accum, [key, value], index) => {
        if (filterItemsFlags[index]) {
            return Object.assign(Object.assign({}, accum), { [key]: value });
        }
        return accum;
    }, {});
};
exports.default = callableObjectFilter;
